import useSWR from "swr";
import axios, { AxiosError } from "axios";

import { Option } from "models/Option";

export type HistoricalShipmentCountries = {
  originCountryCodes: string[];
  destinationCountryCodes: string[];
};

const emptyCountries: HistoricalShipmentCountries = {
  originCountryCodes: [],
  destinationCountryCodes: [],
};

export const useGetHistoricalShipmentCountries = () => {
  const { data, error, isLoading } = useSWR<
    HistoricalShipmentCountries,
    AxiosError
  >(
    "/api/carriers/historicalShipmentCountries",
    (url) =>
      axios
        .get<HistoricalShipmentCountries>(url)
        .then((response) => response.data),
    { keepPreviousData: true, revalidateOnFocus: false }
  );

  return {
    data: data ?? emptyCountries,
    error,
    isLoading,
  };
};

export const getShipmentCountryOptions = (
  countryCodes: string[],
  selectedCountryCodes: string[]
): Option<string>[] =>
  Array.from(new Set([...countryCodes, ...selectedCountryCodes]))
    .sort((a, b) => a.localeCompare(b))
    .map((countryCode) => ({
      key: countryCode,
      value: countryCode,
      text: countryCode,
    }));
